/**
 * NotificationBell Component
 * ปุ่มระฆังแสดง notification badge พร้อม dropdown
 */

import React, { useState, useRef, useEffect } from 'react'
import { BellIcon } from '@heroicons/react/24/outline'
import { motion } from 'framer-motion'
import NotificationDropdown from './NotificationDropdown'
import { useNotifications } from '../../hooks/useNotifications'

const NotificationBell: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const { unreadCount } = useNotifications()

  console.log('NotificationBell render:', { isDropdownOpen, unreadCount })

  // Close dropdown เมื่อคลิกข้างนอก
  useEffect(() => {
    if (!isDropdownOpen) return

    const handleClickOutside = (event: MouseEvent) => {
      console.log('handleClickOutside fired', event.target)
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        console.log('Closing dropdown from outside click')
        setIsDropdownOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [isDropdownOpen])

  const handleClick = () => {
    console.log('handleClick called! Current state:', isDropdownOpen)
    const newState = !isDropdownOpen
    setIsDropdownOpen(newState)
    console.log('Setting new state to:', newState)
  }

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Bell Button - SIMPLIFIED */}
      <button
        type="button"
        onClick={handleClick}
        className={`relative p-2 rounded-lg transition-all duration-200 ${
          isDropdownOpen
            ? 'text-blue-600 bg-blue-50 ring-2 ring-blue-200'
            : 'text-gray-600 hover:text-blue-600 hover:bg-gray-50'
        }`}
        aria-label="การแจ้งเตือน"
      >
        <BellIcon className="w-6 h-6" />

        {/* Unread Badge */}
        {unreadCount > 0 && (
          <motion.span
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            className="absolute -top-1 -right-1 flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full border-2 border-white shadow-sm pointer-events-none"
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </motion.span>
        )}

        {/* Ping animation for new notifications */}
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 flex h-5 w-5 pointer-events-none">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
          </span>
        )}
      </button>

      {/* Dropdown */}
      <NotificationDropdown
        isOpen={isDropdownOpen}
        onClose={() => {
          console.log('onClose called from dropdown')
          setIsDropdownOpen(false)
        }}
        maxItems={5}
      />
    </div>
  )
}

export default NotificationBell
